import { Accordion, AccordionTypes, Icon, Notice, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Text, Pressable } from 'native-base';
import React, { useEffect, useState } from 'react';

import { AssetNoticesNormalized } from '../../pages/BatchTicket/components/DynamicAsset/components/AssetNotices';

type NoticeAsset = AssetNoticesNormalized;

interface NoticesAccordionProps {
  notices: NoticeAsset[];
  handleHideNotice?: (index: number, notice: NoticeAsset) => void;
}

const closeNoticesAccordionKey = 'GENIAL_CLOSE_NOTICES_ACCORDION';
const formatDate = 'dd/MM/yyyy';

export const NoticesAccordion = ({ notices, handleHideNotice }: NoticesAccordionProps) => {
  const [accordionState, setAccordionState] = useState<AccordionTypes.Status>('opened');

  const handlePress = async () => {
    const currentAccordionState = accordionState === 'opened';
    const dateCloseNoticesAccordion = await Utils.Storage.GetItem(closeNoticesAccordionKey);

    if (currentAccordionState && !dateCloseNoticesAccordion) {
      const currentDate = Utils.Mask.DateFormat(new Date(), formatDate);
      await Utils.Storage.SetItem(closeNoticesAccordionKey, currentDate);
    }

    setAccordionState((prevState) => (prevState === 'closed' ? 'opened' : 'closed'));
  };

  useEffect(() => {
    const validateInitialStateAccordion = async () => {
      const dateCloseNoticesAccordion = await Utils.Storage.GetItem(closeNoticesAccordionKey);
      const currentDate = Utils.Mask.DateFormat(new Date(), formatDate);

      if (dateCloseNoticesAccordion && dateCloseNoticesAccordion !== currentDate) {
        Utils.Storage.RemoveItem(closeNoticesAccordionKey);
      }

      if (dateCloseNoticesAccordion && dateCloseNoticesAccordion === currentDate) {
        setAccordionState('closed');
      }
    };

    validateInitialStateAccordion();
  }, []);

  return (
    <Accordion
      testId="alerts-info"
      status={accordionState}
      onPress={handlePress}
      hasShadow={false}
      containerProps={{ bg: Color.background, p: Spacing['inline.xxxs'], flex: 1, w: 'full' }}
      forceDesktopLayout>
      <Accordion.Visible w="full" flex={1}>
        <Pressable onPress={handlePress}>
          <HStack alignItems="center" space={Spacing['inline.nano']}>
            <Icon name="Info" size="xxs" color={Color['neutral.dark']} />
            <Text color={Color['neutral.dark']} variant="semibold">
              Informações importantes
            </Text>
          </HStack>
        </Pressable>
      </Accordion.Visible>
      <Accordion.Expanded forceDesktopLayout>
        <VStack space={Spacing['stack.xxxs']}>
          {notices.map((notice, index) => (
            <Notice
              key={`notice-${notice.id}-${index}`}
              {...notice}
              {...(notice.ableToClose &&
                handleHideNotice && { onPress: () => handleHideNotice(index, notice) })}
            />
          ))}
        </VStack>
      </Accordion.Expanded>
    </Accordion>
  );
};
